'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function Modal(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    closeModal = _ref.closeModal;
	return _react2.default.createElement(
		'div',
		{ className: 'ip-modal ' + className },
		_react2.default.createElement('div', { className: 'ip-modal-overlay', onClick: closeModal }),
		_react2.default.createElement(
			'div',
			{ className: 'ip-modal-inner' },
			_react2.default.createElement(
				'button',
				{ className: 'ip-modal-close', onClick: closeModal },
				_react2.default.createElement(_SvgIcon2.default, { icon: 'close-thin' })
			),
			_react2.default.createElement(
				'div',
				{ className: 'ip-msgModal-icons' },
				_react2.default.createElement(_SvgIcon2.default, { icon: 'error' }),
				_react2.default.createElement(_SvgIcon2.default, { icon: 'check' })
			),
			_react2.default.createElement(
				'div',
				{ className: 'ip-msgModalConfirmation-icons' },
				_react2.default.createElement(_SvgIcon2.default, { icon: 'check' }),
				_react2.default.createElement(_SvgIcon2.default, { icon: 'close-thin' })
			),
			_react2.default.createElement(
				'div',
				{ className: 'ip-modal-content' },
				children
			)
		)
	);
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.js
// module id = 96
// module chunks = 0 1